import { Vector3, Tools } from '@babylonjs/core';
import { SeadevShedBuilder } from './ssb_builder';
import { fabric } from 'fabric';
import * as helpers from './helpers';
import { ePackageType, constants, endGable2D, sideGable2D, reverseSides2D } from './ssb_constants';
import * as FontFaceObserver from 'fontfaceobserver';
import { isEmptyObject } from 'jquery';

export class Seadev2DFloorPlan {
	private _shedData: SeadevShedBuilder;
	private _scale: number = 20;
	private _canvas: fabric.Canvas;
	private _wCanvas: number = 1530;
	private _hCanvas: number = 890;
	private _wShed: number;
	private _dShed: number;
	private _isShedRotation: boolean;
	private _measureBones = [];
	private _centerWallPoint: fabric.Point;
	private _fontFamily: string = 'proxima-nova';
	private _isShowRunnerDirection: boolean = false;

	constructor(shedData: SeadevShedBuilder) {
		this.setShedData(shedData);
		this.initCanvas();
		this.loadFont(this._fontFamily);
		this.setScale();
	}

	generate2D = () => {
		this.draw2DFloorPlan();
		this.setMeasure();
		this.setWallName();
		this.setSymbolLegend();
		this.setUpgradeItems();
		this.setNotation();
		this.renderCanvas();
		// this.handleZoom();
	};

	/**
	 * Capture 2D for cart checkout ....
	 */
	capture2D = () => {
		this.generate2D();
		const dataURL = this._canvas.toDataURL({ format: 'png' });
		jQuery('.woocommerce.single input[name="ssb-option-2d-floor-plan"], #floor-plan').val(
			dataURL,
		);
	};

	/**
	 * Get bones for floor plan
	 *
	 * @param bones
	 * @returns
	 */
	getFloorBones = (bones) => {
		let wallBones = ['b_b_l1', 'b_b_r1', 'b_f_r1', 'b_f_l1', 'b_b_l1'];

		this._measureBones['front'] = { left: 'b_f_l1', right: 'b_f_r1' };
		this._measureBones['back'] = { left: 'b_b_l1', right: 'b_b_r1' };
		this._measureBones['left'] = { left: 'b_b_l1', right: 'b_f_l1' };
		this._measureBones['right'] = { left: 'b_b_r1', right: 'b_f_r1' };
		this._measureBones['porch'] = { left: 'b_f_l1', right: 'b_f_r1' };
		this._measureBones['top_front'] = { left: 'b_f_l1', right: 'b_f_r1' };
		this._measureBones['top_back'] = { left: 'b_b_l1', right: 'b_b_r1' };

		if ('structure_lean_to_with_front_porch' === this._shedData._shedType) {
			wallBones = ['b_f_l1', 'b_b_l1', 'b_b_r1', 'b_f_r1', 'b_f_p1', 'b_b_p1', 'b_b_l1'];
		} else if (this._shedData.isSidePorchCabin()) {
			wallBones = ['b_f_l1', 'b_b_l1', 'b_b_r1', 'b_f_r1', 'b_p_r1', 'b_p_l1', 'b_b_l1'];
		} else if (
			'structure_ranch_cabin' === this._shedData._shedType ||
			this._shedData.isAframeSingleGable()
		) {
			wallBones = [
				'b_p_l1',
				'b_b_m4',
				'b_b_l1',
				'b_b_l1',
				'b_b_r1',
				'b_f_r1',
				'b_f_l1',
				'b_p_l4',
				'b_b_l1',
			];

			this._measureBones['left'] = { left: 'b_p_l1', right: 'b_f_l1' };
			this._measureBones['inner_left'] = { left: 'b_b_l1', right: 'b_b_m4' };
			this._measureBones['back'] = { left: 'b_b_l1', right: 'b_b_r1' };
			this._measureBones['inner_back'] = { left: 'b_p_l1', right: 'b_b_m4' };
		} else if (this._shedData.isDeluxeCornerLeftPorch()) {
			wallBones = [
				'b_f_r1',
				'b_b_r1',
				'b_b_l1',
				'b_p_l1',
				'b_p_r1',
				'b_f_r1',
				'b_f_r4',
				'b_f_r6',
				'b_f_l4',
				'b_f_l1',
			];

			this._measureBones['front'] = { left: 'b_f_l1', right: 'b_f_l4' };
			this._measureBones['inner_front'] = { left: 'b_f_r4', right: 'b_f_r1' };
			this._measureBones['inner_right'] = { left: 'b_f_r4', right: 'b_f_r6' };
		} else if (this._shedData.isFrontPorch()) {
			wallBones = ['b_f_l1', 'b_f_r1', 'b_p_r1', 'b_p_l1', 'b_b_l1', 'b_b_r1', 'b_f_r1'];
		} else if (this._shedData.isMiddlePorch()) {
			wallBones = [
				'b_p_l3',
				'b_f_m4',
				'b_b_m4',
				'b_p_l1',
				'b_b_l1',
				'b_b_r1',
				'b_f_r1',
				'b_f_l1',
				'b_p_l1',
			];

			this._measureBones['left_back'] = { left: 'b_b_l1', right: 'b_p_l1' };
			this._measureBones['left_front'] = { left: 'b_p_l3', right: 'b_f_l1' };
			this._measureBones['front_inner_porch'] = { left: 'b_p_l1', right: 'b_p_l3' };
		} else if (this._shedData.isCornerPorchLeft()) {
			wallBones = [
				'b_f_l1',
				'b_b_m4',
				'b_p_l1',
				'b_b_l1',
				'b_b_r1',
				'b_f_r1',
				'b_p_l4',
				'b_p_l1',
			];

			this._measureBones['left'] = { left: 'b_b_l1', right: 'b_p_l1' };
			this._measureBones['inner_front'] = { left: 'b_p_l1', right: 'b_b_m4' };
			this._measureBones['inner_left'] = { left: 'b_p_l1', right: 'b_f_l1' };
		} else if (this._shedData.isSidePorch()) {
			if ('structure_hiproof' !== this._shedData._shedType) {
				wallBones = ['b_f_l1', 'b_b_l1', 'b_b_r1', 'b_f_r1', 'b_p_r1', 'b_p_l1', 'b_b_l1'];
			}
		} else if ('structure_alpinechalet' === this._shedData._shedType) {
			wallBones = [
				'b_b_m1',
				'b_f_m1',
				'b_f_r1',
				'b_b_r1',
				'b_b_l1',
				'b_f_l1',
				'b_p_l4',
				'b_f_m1',
			];

			this._measureBones['dormer'] = { left: 'b_b_t1', right: 'b_f_t1' };
		} else if ('structure_monitorbarns_helmuth' === this._shedData._shedType) {
			wallBones = [
				'b_b_l5',
				'b_b_l2',
				'b_f_l2',
				'b_f_r2',
				'b_b_r2',
				'b_b_l5',
				'b_f_l5',
				'b_f_r5',
				'b_b_r5',
			];

			this._measureBones['front'] = { left: 'b_b_l2', right: 'b_b_r2' };
			this._measureBones['back'] = { left: 'b_f_l2', right: 'b_f_r2' };
			this._measureBones['top_left'] = { left: 'b_b_l5', right: 'b_f_l5' };
			this._measureBones['top_right'] = { left: 'b_b_r5', right: 'b_f_r5' };
		} else if ('structure_old_west_modular' === this._shedData._shedType) {
			wallBones = ['b_b_l2', 'b_f_l2', 'b_f_r2', 'b_b_r2', 'b_b_l2'];

			this._measureBones['front'] = { left: 'b_f_l2', right: 'b_f_r2' };
			this._measureBones['back'] = { left: 'b_b_l2', right: 'b_b_r2' };
			this._measureBones['left'] = { left: 'b_b_l2', right: 'b_f_l2' };
			this._measureBones['right'] = { left: 'b_b_r2', right: 'b_f_r2' };
		} else if (
			'structure_lakeside_bunkie_gambrel_roof' === this._shedData._shedType ||
			'structure_lakeside_bunkie_gable_roof' === this._shedData._shedType
		) {
			bones['c_b_1'] = {
				position: new Vector3(
					bones['b_f_l1'].position.x,
					0,
					bones['b_f_l1'].position.z + 32 / 12,
				),
			};
			bones['c_b_2'] = {
				position: new Vector3(
					bones['b_f_r1'].position.x,
					0,
					bones['b_f_r1'].position.z + 32 / 12,
				),
			};

			wallBones = ['b_f_l1', 'b_f_r1', 'b_b_r1', 'b_b_l1', 'c_b_1', 'c_b_2', 'b_f_r1'];
		} else if (this._shedData.is2StoryLeanTo()) {
			if (this._shedData.isEnableLeanTo() && this._shedData.isEnableExternalPorch()) {
				wallBones = [
					'lean_to_b_r1',
					'lean_to_b_r2',
					'lean_to_f_r2',
					'lean_to_f_r1',
					'lean_to_b_r1',
					'b_b_l1',
					'b_f_l1',
					'b_f_r1',
					'porch_f_l1',
					'porch_b_l1',
					'b_b_l1',
				];
			} else if (this._shedData.isEnableExternalPorch()) {
				wallBones = [
					'b_b_l1',
					'porch_b_l1',
					'porch_f_l1',
					'b_f_l1',
					'b_b_l1',
					'b_b_r1',
					'b_f_r1',
					'b_f_l1',
				];
			} else if (this._shedData.isEnableLeanTo()) {
				wallBones = [
					'lean_to_b_r1',
					'lean_to_b_r2',
					'lean_to_f_r2',
					'lean_to_f_r1',
					'lean_to_b_r1',
					'b_b_l1',
					'b_f_l1',
					'b_f_r1',
				];
			}

			this._measureBones['lean_to_right'] = { left: 'lean_to_b_r2', right: 'lean_to_f_r2' };
			this._measureBones['lean_to_back'] = { left: 'lean_to_b_r1', right: 'lean_to_b_r2' };
			this._measureBones['lean_to_front'] = { left: 'lean_to_f_r1', right: 'lean_to_f_r2' };
			this._measureBones['top_left'] = { left: 'b_b_l1', right: 'b_f_l1' };
			this._measureBones['top_right'] = { left: 'b_b_r1', right: 'b_f_r1' };
		} else if (this._shedData.isExternalPorch()) {
			const location = this._shedData._externalPorchLocation;

			if ('front' === location) {
				bones['c_b_1'] = {
					position: new Vector3(
						bones['b_f_l1'].position.x,
						0,
						bones['b_f_l1'].position.z + this._shedData._porchWidth,
					),
				};
				bones['c_b_2'] = {
					position: new Vector3(
						bones['b_f_r1'].position.x,
						0,
						bones['b_f_r1'].position.z + this._shedData._porchWidth,
					),
				};

				wallBones = [
					'b_b_l1',
					'b_b_r1',
					'b_f_r1',
					'b_f_l1',
					'b_b_l1',
					'c_b_1',
					'c_b_2',
					'b_b_r1',
				];
			} else if ('left' === location) {
				bones['c_b_1'] = {
					position: new Vector3(
						bones['b_f_l1'].position.x - this._shedData._porchWidth,
						0,
						bones['b_f_l1'].position.z,
					),
				};
				bones['c_b_2'] = {
					position: new Vector3(
						bones['b_b_l1'].position.x - this._shedData._porchWidth,
						0,
						bones['b_b_l1'].position.z,
					),
				};

				wallBones = ['b_f_l1', 'b_b_l1', 'b_b_r1', 'b_f_r1', 'c_b_1', 'c_b_2', 'b_b_l1'];
			}
		} else if (
			'mainus_quaker' === this._shedData._shedType ||
			'structure_saltbox_mwshed' === this._shedData._shedType
		) {
			wallBones = ['b_b_l1', 'b_b_r4', 'b_f_r4', 'b_f_l1', 'b_b_l1'];

			this._measureBones['front'] = { left: 'b_f_l1', right: 'b_f_r4' };
			this._measureBones['back'] = { left: 'b_b_l1', right: 'b_b_r4' };
		} else if ('structure_quaker_wannabuysheds' === this._shedData._shedType) {
			bones['c_b_1'] = {
				position: new Vector3(
					bones['b_f_l1'].position.x - 1,
					0,
					bones['b_f_l1'].position.z,
				),
			};
			bones['c_b_2'] = {
				position: new Vector3(
					bones['b_b_l1'].position.x - 1,
					0,
					bones['b_b_l1'].position.z,
				),
			};

			wallBones = [
				'b_b_l1',
				'b_b_r1',
				'b_f_r1',
				'b_f_l1',
				'b_b_l1',
				'c_b_2',
				'c_b_1',
				'b_f_l1',
			];
		} else if (this._shedData.isDoubleGable()) {
			wallBones = [
				'b_p_l1',
				'b_b_m4',
				'b_b_m8',
				'b_p_l3',
				'b_b_l1',
				'b_b_r1',
				'b_f_r1',
				'b_f_l1',
				'b_p_l3',
			];

			this._measureBones['left_front'] = { left: 'b_p_l1', right: 'b_f_l1' };
			this._measureBones['left_back'] = { left: 'b_b_l1', right: 'b_p_l3' };
			this._measureBones['front_inner_porch'] = { left: 'b_b_m8', right: 'b_b_m4' };
		}

		return wallBones;
	};

	/**
	 * Set Wall Name
	 */
	setWallName = () => {
		let side = [
			helpers.getSideLabel('back', 'Back'),
			helpers.getSideLabel('front', 'Front'),
			helpers.getSideLabel('right', 'Left'),
			helpers.getSideLabel('left', 'Right'),
		];

		if (this._isShedRotation)
			side = [
				helpers.getSideLabel('right', 'Left'),
				helpers.getSideLabel('left', 'Right'),
				helpers.getSideLabel('front', 'Front'),
				helpers.getSideLabel('back', 'Back'),
			];

		const wallLeft = new fabric.Text(side[0], {
			fontSize: 14,
			fontWeight: 700,
			fill: '#5E6578',
			top: 40,
			fontFamily: this._fontFamily,
		});
		const wallRight = new fabric.Text(side[1], {
			fontSize: 14,
			fontWeight: 700,
			fill: '#5E6578',
			top: 650,
			fontFamily: this._fontFamily,
		});
		const wallFront = new fabric.Text(side[2], {
			fontSize: 14,
			fontWeight: 700,
			fill: '#5E6578',
			top: 340,
			left: 240,
			fontFamily: this._fontFamily,
		});
		const wallBack = new fabric.Text(side[3], {
			fontSize: 14,
			fontWeight: 700,
			fill: '#5E6578',
			top: 340,
			left: this._wCanvas - 200,
			fontFamily: this._fontFamily,
		});

		this._canvas.add(wallLeft).add(wallRight).add(wallFront).add(wallBack);
		wallLeft.left = this.getHCenter(wallLeft.width);
		wallRight.left = this.getHCenter(wallRight.width);
	};

	/**
	 * Group component by side
	 */
	groupComponentBySide = () => {
		const allComponents = this.getAllComponents();
		const results = [];

		for (let k in allComponents) {
			const component = allComponents[k];

			const componentIncludes = ['door', 'windows', 'vent'];
			const sideExcludes = [
				'roof',
				'roof_left',
				'roof_right',
				'diagonal_right',
				'left_inner_porch',
				'right_inner_porch',
			];
			if (
				helpers.hasKeyInArray(sideExcludes, component.side) ||
				!helpers.hasKeyInArray(componentIncludes, component.type)
			)
				continue;

			if ('Opening' !== component.name) {
				component.position2D = this._shedData.getPosition2D(
					component.side,
					component.meshes,
					component.meshes[0].position,
					component.type,
					component.name,
					component.uuid,
				);
			}

			results.push(component);
		}

		const group = helpers.groupBy(results, 'side');

		return group;
	};

	setUpgradeItems = () => {
		if (1 !== Number((<any>window).ssb.upgrade_to_2d)) return;

		const upgradeData = [];
		const upgradesHTML = jQuery(
			'.ssb-configurator-options.package input:checked, .ssb-configurator-options.other input:checked',
		);

		upgradesHTML.each((i, v) => {
			const name = jQuery(v).attr('origin-value')
				? jQuery(v).attr('origin-value')
				: jQuery(v).data('option-value');
			const quantity = Number(jQuery(v).closest('div').find('.upgrade-quantity').val()) || 1;
			const groupName = jQuery(v)
				.closest('.ssb-configurator-group')
				.find('.ssb-configurator-group-name')
				.text();
			const group = jQuery(v).attr('origin-group-name')
				? jQuery(v).attr('origin-group-name')
				: groupName;
			upgradeData.push({
				name,
				quantity,
				group,
			});
		});

		const groups = helpers.groupBy(upgradeData, 'group');

		if (Object.keys(groups).length === 0) return;

		const offsetLeft = 20;
		const maxWidth = 180;
		const upgradeTitle = new fabric.Text('UPGRADE ITEMS:', {
			fontWeight: 700,
			fontSize: 12,
			fill: '#000000',
			left: offsetLeft,
			top: 40,
			fontFamily: this._fontFamily,
		});
		let currentTop = upgradeTitle.top + upgradeTitle.height;

		this._canvas.add(upgradeTitle);

		for (const key in groups) {
			const group = groups[key];
			const upgradeName = new fabric.Text(key, {
				top: currentTop + 15,
				left: offsetLeft,
				fontWeight: 700,
				fontSize: 12,
				fill: '#000000',
				fontFamily: this._fontFamily,
			});
			this._canvas.add(upgradeName);

			group.forEach((g, i) => {
				if (0 === i) currentTop = upgradeName.top + upgradeName.height;

				let text = '• ' + g.name;
				if (g.quantity > 1) text += ' x ' + g.quantity;

				const upgradeBox = new fabric.Textbox(text, {
					top: currentTop + 5,
					left: offsetLeft,
					width: maxWidth,
					fontSize: 12,
					fill: '#000000',
					fontFamily: this._fontFamily,
				});
				currentTop = upgradeBox.top + upgradeBox.height;

				this._canvas.add(upgradeBox);
			});
		}
	};

	/**
	 * Set Symbol Legend
	 *
	 * @returns void
	 */
	setSymbolLegend = () => {
		let currentWidth = this.getShedWidth();
		let currentDepth = this.getShedDepth();
		const selectedSize = jQuery('.ssb-option.size-area').children('option:selected');
		const height = Number(
			jQuery(`#ssb-configurator-size-height`).children('option:selected').data('size-height'),
		);
		const sizeLabel = helpers.getSizeLabel(selectedSize, height);

		if (this._shedData.isSideGable()) {
			[currentWidth, currentDepth] = [currentDepth, currentWidth];
		}

		if (this._shedData.isExcludePorchMeasurement() && this._shedData.isSidePorch()) {
			if (this._shedData.isSideGable()) {
				currentDepth -= this._shedData._porchWidth;
			} else {
				currentWidth -= this._shedData._porchWidth;
			}
		}

		const boxWidth = 1000;
		const components = this.getComponentsSymbol();
		const shedNameText =
			this._shedData.getSettingData('product_name') + ` ${sizeLabel['widthDepthLabel']}`;
		const shedName = new fabric.Text(shedNameText, {
			fill: '#000',
			fontSize: 24,
			top: this._hCanvas - 190,
			left: 0,
			fontWeight: 700,
			fontFamily: this._fontFamily,
		});
		this._canvas.add(shedName);
		shedName.left = this.getHCenter(shedName.width);

		if (0 === components.length) return;

		const symbolBox = new fabric.Rect({
			width: boxWidth,
			height: 24,
			fill: '#EDEDED',
			strokeWidth: 1,
			stroke: '#EDEDED',
		});
		const symbolText = new fabric.Text('SYMBOL LEGEND', {
			fill: '#000000',
			fontSize: 12,
			fontWeight: 700,
			fontFamily: this._fontFamily,
			top: 6,
			left: 14,
		});

		const rowsHeight = 26;
		const boxGroup = [];
		const cWidth = boxWidth / 4;
		let offset = 0;
		let firstTop = symbolBox.top - 2;
		let countRow = 0;

		if (this._isShowRunnerDirection) {
			components.push({
				wildcard: '',
				type: 'runner',
				label: 'Runner Direction:',
				name: 'runner_direction',
			});
		}

		for (let i = 0; i < components.length; i++) {
			const component = components[i];
			offset = 0 === i || 0 === i % 4 ? 0 : offset + 1;
			countRow = 0 === i % 4 ? countRow + 1 : countRow;
			const left = offset * cWidth;
			const top = firstTop + countRow * rowsHeight;
			const iconLeft = 'runner' === component.type ? 107 : 40;
			const nameLeft = 'runner' === component.type ? 15 : 65;
			const iconTop =
				'runner' === component.type
					? 9
					: 'loft' === component.type || 'dormer' === component.type
						? 8
						: 'partial_wall' === component.type
							? 10
							: 5;
			const componentBox = new fabric.Rect({
				width: cWidth,
				height: rowsHeight,
				fill: '#FFF',
				stroke: '#E4E4E4',
				strokeWidth: 1,
				left,
				top,
			});
			const componentWC = new fabric.Text(component.wildcard, {
				left: left + 15,
				top: top + 7,
				fill: '#000000',
				width: 20,
				textAlign: 'center',
				fontSize: 12,
				fontWeight: 700,
				fontFamily: this._fontFamily,
			});
			const componentName = new fabric.Text(component.label, {
				left: left + nameLeft,
				top: top + 7,
				fill: '#000000',
				fontSize: 11,
				fontFamily: this._fontFamily,
			});
			const componentIconStr = this.getComponentInit('icon', component.type, component.name);

			if ('runner' === component.type) {
				boxGroup.push(componentBox, componentName);
			} else {
				boxGroup.push(componentBox, componentWC, componentName);
			}

			fabric.loadSVGFromString(componentIconStr, (objects, options) => {
				const obj = fabric.util.groupSVGElements(objects, options);
				obj.set({ left: left + iconLeft, top: top + iconTop });
				boxGroup.push(obj);
			});
		}

		const group = new fabric.Group([symbolBox, symbolText, ...boxGroup]);

		this._canvas.add(group);
		group.top = shedName.top + 50;
		group.left = this.getHCenter(group.width);
	};

	/**
	 * Set Notation For Manufacture Dealer System
	 */
	setNotation = () => {
		if (!helpers.isEnableManufactureFeature()) return;
		const notationText = new fabric.Text(
			"✱ For the builders' references, options listed on this 2D floorplan use names defined by the factory.",
			{
				fill: '#000000',
				fontSize: 10,
				fontWeight: 400,
				fontFamily: this._fontFamily,
				fontStyle: 'italic',
				textAlign: 'right',
			},
		);
		this._canvas.add(notationText);
		notationText.left = this._wCanvas - notationText.width - 20;
		notationText.top = this._hCanvas - notationText.height;
	};

	/**
	 * Draw 2D Floor Plan and Put component to Walls
	 */
	draw2DFloorPlan = () => {
		const gShed = [];
		const bones = this._shedData._bones;
		const wallPoints = [];
		const wallBones = this.getFloorBones(bones);

		wallBones.forEach((key) => {
			if (bones[key])
				wallPoints.push({
					x: -this.scale(bones[key].position.x),
					y: this.scale(bones[key].position.z),
				});
		});

		const walls = new fabric.Polyline(wallPoints, {
			stroke: 'black',
			fill: 'white',
			strokeWidth: 3,
		});
		const components = this.placeComponents();

		// Hard code to hide wall measure for structure_monitorbarns_helmuth model
		if (
			helpers.isShowComponentPosition() &&
			'structure_monitorbarns_helmuth' !== this._shedData._shedType
		) {
			const componentGroups = this.groupComponentBySide();
			for (const side in componentGroups) {
				const wallMeasure = this.drawComponentMeasure(side, componentGroups);
				components.push(wallMeasure);
			}
		}

		gShed.push(walls, ...components);

		const shedWalls = new fabric.Group(gShed, { top: 0 });
		this._canvas.add(shedWalls);
		let groupHeight = shedWalls.height;
		let groupWidth = shedWalls.width;
		let groupOffset = 0;

		if (this._isShedRotation) {
			shedWalls.rotate(90);
			groupHeight = shedWalls.width;
			groupWidth = shedWalls.height;
			groupOffset = shedWalls.height;
		}

		shedWalls.left = this.getHCenter(groupWidth) + groupOffset;
		shedWalls.top = 350 - groupHeight / 2;
		this._centerWallPoint = walls.getCenterPoint();
	};

	/**
	 * Create and place component in canvas
	 *
	 * @returns component
	 */
	placeComponents = () => {
		const loft = this.getLoftComponent();
		const components = this.getAllComponents();
		const results = [];

		if (loft) {
			const componentIcon = this.drawLoftComponentIcon(loft);
			if (componentIcon) results.push(...componentIcon);
		}
		if (this._shedData._isEnableTackRoom) {
			const componentTackRoomIcon = this.drawTackRoomComponentIcon();
			if (componentTackRoomIcon) results.push(...componentTackRoomIcon);
		}

		for (const k in components) {
			const component = components[k];
			const componentIcon = this.drawComponentIcon(component);

			if (0 === componentIcon.length) continue;

			results.push(...componentIcon);
		}

		return results;
	};

	/**
	 * Set Measure position
	 */
	setMeasure = () => {
		const selectedSize = jQuery('.ssb-option.size-area').children('option:selected');
		const height = Number(
			jQuery(`#ssb-configurator-size-height`).children('option:selected').data('size-height'),
		);
		const sizeLabel = helpers.getSizeLabel(selectedSize, height);
		let widthLabel: any = this._wShed;
		let depthLabel: any = this._dShed;

		if (sizeLabel['isCustomLabel']) {
			let labelArr = sizeLabel['widthDepthLabel'].split('x');
			if (labelArr.length > 2) {
				labelArr = labelArr.map((e) => e.trim());
				if (this._shedData.isSideGable()) {
					widthLabel = labelArr[1];
					depthLabel = labelArr[0];
				} else {
					widthLabel = labelArr[0];
					depthLabel = labelArr[1];
				}

				if (this._isShedRotation) {
					[widthLabel, depthLabel] = [depthLabel, widthLabel];
				}
			}
		}

		// Hard code to set label width for structure_monitorbarns_helmuth
		const sizeLabels = sizeLabel['widthDepthLabel'].split('x');
		if ('structure_monitorbarns_helmuth' === this._shedData._shedType && sizeLabels[0]) {
			if (this._isShedRotation) {
				depthLabel = sizeLabels[0];
			} else {
				widthLabel = sizeLabels[0];
			}
		}

		const offsetLeft = this._isShedRotation
			? -this._centerWallPoint.y
			: this._centerWallPoint.x;
		const offsetTop = this._isShedRotation ? this._centerWallPoint.x : this._centerWallPoint.y;
		const measureBottom = this.drawShedMeasure(
			`${widthLabel}`,
			this.scale(this._wShed),
			'left',
			!sizeLabel['isCustomLabel'],
		);
		this._canvas.add(measureBottom);
		measureBottom.left = this.getHCenter(measureBottom.width) + offsetLeft;
		measureBottom.top = 600;

		const measureRight = this.drawShedMeasure(
			`${depthLabel}`,
			this.scale(this._dShed),
			'back',
			!sizeLabel['isCustomLabel'],
		);
		this._canvas.add(measureRight);
		measureRight.top = 340 + measureRight.width / 2 + 10 + offsetTop;
		measureRight.left = this._wCanvas - 250;

		if (
			'structure_lakeside_bunkie_gambrel_roof' === this._shedData._shedType ||
			'structure_lakeside_bunkie_gable_roof' === this._shedData._shedType
		) {
			if (this._isShedRotation) {
				measureBottom.left += this.scale(32 / 12 / 2);
			} else {
				measureRight.top -= this.scale(32 / 12 / 2);
			}
		} else if (this._shedData.isSidePorchCabin()) {
			if (this._isShedRotation) {
				measureRight.top -= this.scale(this._shedData._porchWidth / 2);
			} else {
				measureBottom.left -= this.scale(this._shedData._porchWidth / 2);
			}
		}

		if (this._shedData.is2StoryLeanTo()) {
			let offset = 0;
			if (this._shedData.isEnableExternalPorch() && !this._shedData.isEnableLeanTo()) {
				offset = -Vector3.Distance(
					this._shedData._bones['porch_b_l1'].position,
					this._shedData._bones['b_b_l1'].position,
				);
			} else if (!this._shedData.isEnableExternalPorch() && this._shedData.isEnableLeanTo()) {
				offset = Vector3.Distance(
					this._shedData._bones['lean_to_b_r1'].position,
					this._shedData._bones['lean_to_b_r2'].position,
				);
			}

			if (this._isShedRotation) {
				measureRight.top += this.scale(offset / 2);
			} else {
				measureBottom.left += this.scale(offset / 2);
			}
		} else if (this._shedData.isExternalPorch()) {
			if ('front' === this._shedData._externalPorchLocation) {
				if (this._isShedRotation) {
					measureBottom.left += this.scale(this._shedData._porchWidth / 2);
				} else {
					measureRight.top -= this.scale(this._shedData._porchWidth / 2);
				}
			} else if ('left' === this._shedData._externalPorchLocation) {
				if (this._isShedRotation) {
					measureRight.top -= this.scale(this._shedData._porchWidth / 2);
				} else {
					measureBottom.left -= this.scale(this._shedData._porchWidth / 2);
				}
			}
		}
	};

	/**
	 * Init canvas
	 */
	initCanvas = () => {
		this._canvas = new fabric.Canvas('ssb-2d-floor-plan', {
			selection: false,
			backgroundColor: 'white',
			allowTouchScrolling: true,
		});
	};

	/**
	 * Render canvas
	 */
	renderCanvas = () => {
		this._canvas.setDimensions({ width: this._wCanvas, height: this._hCanvas });

		this._canvas.forEachObject((obj) => {
			obj.set({
				evented: false,
			});
		});

		this._canvas.calcOffset();
		this._canvas.renderAll();
	};

	/**
	 * Handle when wheel zoom in || zoom out
	 */
	handleZoom = () => {
		let _this = this;

		_this._canvas.on('mouse:wheel', function (opt) {
			if (opt.e.ctrlKey) {
				let delta = opt.e.deltaY;
				let zoom = _this._canvas.getZoom();

				zoom *= 0.999 ** delta;

				if (zoom > 15) zoom = 15;
				if (zoom < 0.5) zoom = 0.5;

				_this._canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);

				opt.e.preventDefault();
				opt.e.stopPropagation();
			}
		});

		_this._canvas.on('touch:drag', function (opt) {
			console.log('DEBUG opt: ', opt);
		});
	};

	/**
	 * Set scale ratio depends on depth and width
	 */
	setScale = () => {
		const mwCanvas = 800;
		const mhCanvas = 320;

		let _wShed = this.getShedWidth();
		let _dShed = this.getShedDepth();
		let tempWidth = _wShed;
		let tempDepth = _dShed;

		if ('structure_monitorbarns_helmuth' === this._shedData._shedType) {
			tempWidth = 36;
			_wShed = 36;
		} else if (
			'structure_lakeside_bunkie_gambrel_roof' === this._shedData._shedType ||
			'structure_lakeside_bunkie_gable_roof' === this._shedData._shedType
		) {
			tempDepth += 32 / 12;
		} else if (this._shedData.is2StoryLeanTo()) {
			if (this._shedData.isEnableLeanTo() && this._shedData.isEnableExternalPorch()) {
				tempWidth = Vector3.Distance(
					this._shedData._bones['porch_b_l1'].position,
					this._shedData._bones['lean_to_b_r2'].position,
				);
			} else if (this._shedData.isEnableExternalPorch()) {
				tempWidth = Vector3.Distance(
					this._shedData._bones['porch_b_l1'].position,
					this._shedData._bones['b_b_r1'].position,
				);
			} else if (this._shedData.isEnableLeanTo()) {
				tempWidth = Vector3.Distance(
					this._shedData._bones['b_b_l1'].position,
					this._shedData._bones['lean_to_b_r2'].position,
				);
			}
		} else if (this._shedData.isExternalPorch()) {
			if ('left' === this._shedData._externalPorchLocation) {
				tempWidth += this._shedData._porchWidth;
			} else if ('front' === this._shedData._externalPorchLocation) {
				tempDepth += this._shedData._porchWidth;
			}
		} else if (
			this._shedData.isSidePorch() &&
			'structure_hiproof' === this._shedData._shedType
		) {
			_wShed -= this._shedData._porchWidth;
		}

		this._isShedRotation = false;
		if (tempWidth < tempDepth) {
			[_wShed, _dShed] = [_dShed, _wShed];
			[tempWidth, tempDepth] = [tempDepth, tempWidth];
			this._isShedRotation = true;
		} else if (this.isShowRunnerDirection(tempWidth, tempDepth)) {
			this._isShowRunnerDirection = true;
			if ('gable-end-to-gable-end' === this._shedData.getRunnerDirection()) {
				this._isShedRotation = true;
			}
		}

		const wScale = mwCanvas / tempWidth;
		const hScale = mhCanvas / tempDepth;
		const scale = helpers.toFixed3(Math.min(wScale, hScale));

		this._wShed = _wShed;
		this._dShed = _dShed;
		this._scale = scale;
	};

	/**
	 * Set shed data
	 *
	 * @param data shed data
	 */
	setShedData = (data) => {
		this._shedData = data;
	};

	/**
	 * Get Horizontal center point
	 *
	 * @param width distance want to get the middle position
	 *
	 * @returns center of horizontal
	 */
	getHCenter = (width: number) => {
		return this._wCanvas / 2 - width / 2;
	};

	/**
	 * Get shed width
	 *
	 * @returns shed width
	 */
	getShedWidth = () => {
		let wShed = this._shedData.getWidth();

		return wShed;
	};

	/**
	 * Get shed Depth
	 *
	 * @returns shed depth
	 */
	getShedDepth = () => {
		let dShed = this._shedData.getDepth();

		if (this._shedData.isFrontPorch()) dShed += this._shedData._porchWidth;

		return dShed;
	};

	/**
	 * Determines the line number for a component based on the side it belongs to.
	 *
	 * @param {Object} componentSideGroups - An object where keys represent different sides and values are arrays of components.
	 * @param {string} side - The specific side for which we want to get the line number.
	 *
	 * @returns {number} - The line number where the component should be placed.
	 *
	 */
	getComponentLine = (componentSideGroups, side) => {
		let line = 0;
		const components = helpers.hasKeyInObject(componentSideGroups, side)
			? componentSideGroups[side]
			: [];
		if (components.length) {
			line = Object.keys(
				helpers.groupBy(this.allocateComponentLines(components), 'line'),
			).length;
		}

		return line;
	};

	/**
	 * Assigns components to lines based on horizontal overlap.
	 * Components are sorted by their horizontal position, and each component is assigned to the first available line.
	 * The component is assigned to the next line if it overlaps horizontally with any component already on the current line.
	 * A maximum of 4 lines (0 to 3) are used.
	 *
	 * @param {Array} components - List of components with position2D information.
	 *
	 * @returns {Array} - Components with their assigned line.
	 */
	allocateComponentLines = (components) => {
		components.sort(
			(a, b) => a.position2D.horizontal.firstPoint - b.position2D.horizontal.firstPoint,
		);

		const lines = [];
		return components.map((component) => {
			const { horizontal } = component.position2D;
			const range = {
				start: horizontal.firstPoint,
				end: horizontal.lastPoint,
			};

			let assignedLine = -1;
			for (let i = 0; i < lines.length; i++) {
				const lineRanges = lines[i];
				const hasOverlap = lineRanges.some(
					(existingRange) =>
						range.start < existingRange.end && range.end > existingRange.start,
				);
				if (!hasOverlap) {
					assignedLine = i;
					break;
				}
			}

			if (assignedLine === -1 && lines.length < 3) {
				assignedLine = lines.length;
				lines.push([]);
			} else if (assignedLine === -1) {
				assignedLine = 2;
			}

			lines[assignedLine].push(range);

			return {
				...component,
				line: assignedLine,
			};
		});
	};

	/**
	 * Draw Component Measure
	 *
	 * @param side side of shed
	 * @param componentSideGroups list all component of model
	 *
	 * @returns fabric.Object
	 */
	drawComponentMeasure = (side: string, componentSideGroups: Array<any> = []) => {
		const components = helpers.hasKeyInObject(componentSideGroups, side)
			? componentSideGroups[side]
			: [];

		if (0 === components.length) return new fabric.Group();

		const groupComponents = helpers.groupBy(this.allocateComponentLines(components), 'line');
		const bones = this._shedData._bones;
		let items = [];

		for (const lineIndex in groupComponents) {
			const lineComponents = groupComponents[lineIndex];
			let _lastPoint = 0;

			lineComponents.forEach((component, i) => {
				const width = this._shedData.getComponentWidthFromNetWork(component);
				const position2D = helpers.hasKeyInArray(sideGable2D, side)
					? component.meshes[0].position.z
					: component.meshes[0].position.x;
				const firstPoint = position2D - width / 2;
				const lastPoint = position2D + width / 2;
				const baseOffset = helpers.hasKeyInArray(reverseSides2D, side) ? -40 : 40;
				let _offsetMeasure = baseOffset;

				if (helpers.hasKeyInArray(endGable2D, side)) {
					const porchLine = this.getComponentLine(componentSideGroups, 'porch');
					const fontLine = this.getComponentLine(componentSideGroups, 'front');
					const backLine = this.getComponentLine(componentSideGroups, 'back');

					if (
						('front' === side || 'porch' === side) &&
						('structure_lakeside_bunkie_gambrel_roof' === this._shedData._shedType ||
							'structure_lakeside_bunkie_gable_roof' === this._shedData._shedType)
					) {
						_offsetMeasure += this.scale(32 / 12);
					} else if (
						('structure_ranch_cabin' === this._shedData._shedType ||
							this._shedData.isAframeSingleGable()) &&
						'inner_back' === side
					) {
						_offsetMeasure -= this.scale(
							this._shedData.getDepth() - this._shedData._cabinWidth,
						);
					} else if (this._shedData.isCornerPorchLeft() && 'inner_front' === side) {
						_offsetMeasure += this.scale(constants.cornerDepth);
					} else if (this._shedData.isDeluxeCornerLeftPorch()) {
						if ('inner_front' === side) {
							_offsetMeasure +=
								this.scale(3 * constants.deluxeDepth) + porchLine * baseOffset;
						} else if ('front' === side) {
							_offsetMeasure +=
								this.scale(constants.deluxeDepth) + porchLine * baseOffset;
						}
					} else if (this._shedData.isFrontPorch()) {
						if ('front' === side) {
							_offsetMeasure +=
								this.scale(this._shedData._porchWidth) + porchLine * baseOffset;
						}
					} else if (
						this._shedData.isExternalPorch() &&
						'front' === this._shedData._externalPorchLocation &&
						'front' === side
					) {
						_offsetMeasure += this.scale(this._shedData._porchWidth);
					}

					if ('top_front' === side) {
						_offsetMeasure += fontLine * baseOffset;
					}

					if ('top_back' === side) {
						_offsetMeasure += backLine * baseOffset;
					}

					const positionY =
						this.scale(component.meshes[0].position.z) +
						_offsetMeasure +
						baseOffset * component.line;
					const startFirst =
						0 === i
							? {
									x: -this.scale(bones[this._measureBones[side].left].position.x),
									y: positionY,
								}
							: { x: -this.scale(_lastPoint), y: positionY };
					const endFirst = { x: -this.scale(firstPoint), y: positionY };
					const widthFirst = Math.abs(endFirst.x - startFirst.x) / this._scale;

					items = [
						...this.drawMeasureItem(
							widthFirst,
							side,
							lineComponents,
							startFirst,
							endFirst,
						),
						...items,
					];

					const startCenter = { x: -this.scale(firstPoint), y: positionY };
					const endCenter = { x: -this.scale(lastPoint), y: positionY };
					const widthCenter = Math.abs(endCenter.x - startCenter.x) / this._scale;

					items = [
						...this.drawMeasureItem(
							widthCenter,
							side,
							lineComponents,
							startCenter,
							endCenter,
						),
						...items,
					];

					if (lineComponents.length - 1 === i) {
						const startLast = { x: -this.scale(lastPoint), y: positionY };
						const endLast = {
							x: -this.scale(bones[this._measureBones[side].right].position.x),
							y: positionY,
						};
						const widthLast = Math.abs(endLast.x - startLast.x) / this._scale;

						items = [
							...this.drawMeasureItem(
								widthLast,
								side,
								lineComponents,
								startLast,
								endLast,
							),
							...items,
						];
					}
				} else if (helpers.hasKeyInArray(sideGable2D, side)) {
					if (
						('structure_ranch_cabin' === this._shedData._shedType ||
							this._shedData.isAframeSingleGable()) &&
						'inner_left' === side
					) {
						_offsetMeasure -= this.scale(constants.cabinPorchDepth);
					} else if (this._shedData.isCornerPorchLeft() && 'inner_left' === side) {
						_offsetMeasure -= this.scale(constants.cornerWidth);
					} else if ('front_inner_porch' === side) {
						if (this._shedData.isMiddlePorch()) {
							_offsetMeasure -= this.scale(constants.middleDepth);
						} else if (this._shedData.isDoubleGable()) {
							_offsetMeasure -= this.scale(constants.doubleGablePorchDepth);
						}
					} else if (this._shedData.isDeluxeCornerLeftPorch() && 'inner_right' === side) {
						_offsetMeasure += this.scale(this._shedData.deluxePorchGetPorchWidth());
					} else if (this._shedData.isSidePorch() && 'left' === side) {
						_offsetMeasure -= this.scale(this._shedData._porchWidth);
					} else if (this._shedData.is2StoryLeanTo()) {
						const leftComponents = this._shedData.getComponentBySideAndType(
							'left',
							'exterior',
						);
						const sortComps = this._shedData.sortComponentPosition(
							leftComponents,
							'left',
						);

						if ('top_right' === side && !this._shedData.isEnableLeanTo()) {
							_offsetMeasure += this.scale(2);
						}

						if ('top_left' === side && sortComps.length > 0) {
							_offsetMeasure -= this.scale(2);
						}
					} else if (
						this._shedData.isExternalPorch() &&
						'left' === this._shedData._externalPorchLocation &&
						'left' === side
					) {
						_offsetMeasure -= this.scale(this._shedData._porchWidth);
					} else if ('dormer' === side) {
						_offsetMeasure -= this.scale(this.getShedWidth() * (1 / 3)) + baseOffset;
					} else if ('structure_monitorbarns_helmuth' === this._shedData._shedType) {
						const offsetDistance =
							this.scale(
								Math.abs(this._shedData._bones['b_b_l2'].position.x) -
									Math.abs(this._shedData._bones['b_b_l5'].position.x),
							) + baseOffset;

						if ('top_left' === side) {
							_offsetMeasure -= offsetDistance;
						} else if ('top_right' === side) {
							_offsetMeasure += offsetDistance;
						}
					} else if (
						'structure_quaker_wannabuysheds' === this._shedData._shedType &&
						'left' === side
					) {
						_offsetMeasure -= this.scale(1);
					}

					const positionX =
						this.scale(component.meshes[0].position.x) +
						_offsetMeasure +
						baseOffset * component.line;
					const startFirst =
						0 === i
							? {
									x: -positionX,
									y: this.scale(bones[this._measureBones[side].left].position.z),
								}
							: { x: -positionX, y: this.scale(_lastPoint) };
					const endFirst = { x: -positionX, y: this.scale(firstPoint) };
					const widthFirst = Math.abs(endFirst.y - startFirst.y) / this._scale;

					items = [
						...this.drawMeasureItem(
							widthFirst,
							side,
							lineComponents,
							startFirst,
							endFirst,
						),
						...items,
					];

					const startCenter = { x: -positionX, y: this.scale(firstPoint) };
					const endCenter = { x: -positionX, y: this.scale(lastPoint) };
					const widthCenter = Math.abs(endCenter.y - startCenter.y) / this._scale;

					items = [
						...this.drawMeasureItem(
							widthCenter,
							side,
							lineComponents,
							startCenter,
							endCenter,
						),
						...items,
					];

					if (lineComponents.length - 1 === i) {
						const startLast = { x: -positionX, y: this.scale(lastPoint) };
						const endLast = {
							x: -positionX,
							y: this.scale(bones[this._measureBones[side].right].position.z),
						};
						const widthLast = Math.abs(endLast.y - startLast.y) / this._scale;

						items = [
							...this.drawMeasureItem(
								widthLast,
								side,
								lineComponents,
								startLast,
								endLast,
							),
							...items,
						];
					}
				}

				_lastPoint = lastPoint;
			});
		}

		return new fabric.Group([...items]);
	};

	drawShedMeasure = (
		txtText: string | number,
		width: number,
		side: string,
		isCustomLabel: boolean = true,
	) => {
		const start = { x: 0, y: 0 };
		const end = { x: width, y: 0 };
		const items = [...this.drawMeasureItem(txtText, side, [], start, end, isCustomLabel)];
		const group = new fabric.Group([...items]);

		if ('front' === side) {
			group.rotate(90);
		} else if ('right' === side) {
			group.rotate(180);
		} else if ('back' === side) {
			group.rotate(270);
		}

		return group;
	};

	/**
	 * Draw Measure Item
	 *
	 * @param {String|Number} txtText
	 * @param {String} side
	 * @param {Array} components
	 * @param {Object} start
	 * @param {Object} end
	 * @param {Boolean} isCustomLabel
	 *
	 * @returns {Array} measureLine, text, subLineStart, subLineEnd
	 */
	drawMeasureItem = (
		txtText: string | number,
		side: string,
		components: Array<any> = [],
		start: { x: number; y: number },
		end: { x: number; y: number },
		isCustomLabel: boolean = true,
	) => {
		const color = '#424242';
		const strokeColor = '#181818';
		const offsetY = 22;

		let firstPoint = { x: start.x, y: start.y - offsetY };
		let lastPoint = { x: end.x, y: end.y - offsetY };

		let pointStart = [start.x - 5, start.y + 4, start.x + 6, start.y - 6];
		let pointEnd = [end.x - 5, end.y + 4, end.x + 6, end.y - 6];

		const backKeys = ['back', 'inner_back', 'lean_to_back', 'top_back'];
		const rightKeys = ['right', 'inner_right', 'top_right', 'lean_to_right'];
		const leftKeys = [
			'left',
			'inner_left',
			'left_back',
			'left_front',
			'front_inner_porch',
			'dormer',
			'top_left',
		];

		if (components.length > 0) {
			if (helpers.hasKeyInArray(backKeys, side)) {
				firstPoint = { x: start.x, y: start.y + offsetY };
				lastPoint = { x: end.x, y: end.y + offsetY };
			} else if (helpers.hasKeyInArray(rightKeys, side)) {
				firstPoint = { x: start.x + offsetY, y: start.y };
				lastPoint = { x: end.x + offsetY, y: end.y };

				pointStart = [start.x - 5, start.y - 4, start.x + 6, start.y + 6];
				pointEnd = [end.x - 5, end.y - 4, end.x + 6, end.y + 6];
			} else if (helpers.hasKeyInArray(leftKeys, side)) {
				firstPoint = { x: start.x - offsetY, y: start.y };
				lastPoint = { x: end.x - offsetY, y: end.y };

				pointStart = [start.x - 6, start.y - 6, start.x + 5, start.y + 4];
				pointEnd = [end.x - 6, end.y - 6, end.x + 5, end.y + 4];
			}
		}

		const points = [firstPoint, start, end, lastPoint];

		const measureLine = new fabric.Polyline(points, {
			stroke: strokeColor,
			strokeWidth: 1,
			fill: 'rgba(0,0,0,0)',
		});

		const subLineStart = new fabric.Line(pointStart, {
			stroke: strokeColor,
			strokeWidth: 1,
		});

		const subLineEnd = new fabric.Line(pointEnd, {
			stroke: strokeColor,
			strokeWidth: 1,
		});

		const label = isCustomLabel ? helpers.convertUnit(txtText) : `${txtText}`;
		const text = new fabric.Text(label, {
			left: (start.x + end.x) / 2,
			top: (start.y + end.y) / 2,
			fontSize: 10,
			fontWeight: 600,
			fill: color,
			fontFamily: this._fontFamily,
			originX: 'center',
			originY: 'center',
			backgroundColor: '#FFFFFF',
			padding: 20,
		});

		if (components.length > 0) {
			if (this._isShedRotation) {
				text.rotate(270);
			}
		} else {
			if (!this._isShedRotation) {
				if ('back' === side) {
					text.rotate(90);
				}
			} else {
				if ('back' === side) {
					text.rotate(90);
				}
			}
		}

		return [measureLine, text, subLineStart, subLineEnd];
	};

	/**
	 * Get all Component
	 *
	 * @returns all component ignore ramp and flower box
	 */
	getAllComponents = () => {
		const allComponents = this._shedData.getAllComponents();
		const components = helpers.objectFilter(
			allComponents,
			(component) =>
				'ramp' === this._shedData.getBehavior(component.name, component.type) ||
				'flower_box' === this._shedData.getBehavior(component.name, component.type) ||
				'shutters' === this._shedData.getBehavior(component.name, component.type) ||
				component.isHidden ||
				component.isIgnore2D,
		);

		this._shedData._openingList.forEach((opening, i) => {
			const holeWidth = this._shedData._openingWidth + this._shedData._trimLength;
			const firstPointWidth = opening.z - holeWidth / 2;
			const lastPointWidth = opening.z + holeWidth / 2;
			const meshes = [{ position: opening }];

			const position2D = {
				horizontal: { firstPoint: firstPointWidth, lastPoint: lastPointWidth },
			};

			components['opening_' + i + new Date().getTime()] = {
				side: 'left',
				type: 'door',
				name: 'Opening',
				face: 'exterior',
				group: 'door',
				meshes: meshes,
				position2D: position2D,
				holeWidth,
			};
		});

		this._shedData._stairs.forEach((stair, i) => {
			const { side, width, originalKey } = stair.metadata;
			const firstPointWidth = stair.position.x - width / 2;
			const lastPointWidth = stair.position.x + width / 2;
			const position2D = {
				horizontal: { firstPoint: firstPointWidth, lastPoint: lastPointWidth },
			};

			components[`${side}_${stair.name}_` + i + new Date().getTime()] = {
				side,
				meshes: [stair, ...stair.getChildMeshes()],
				type: 'stair',
				name: originalKey,
				face: 'interior',
				group: 'stair',
				position2D: position2D,
				depth: width,
			};
		});

		return this.sortObjectByKey(components, 'width');
	};

	/**
	 * Sorts an object by a specified key in descending order.
	 *
	 * @param {Object} obj - The object to sort.
	 * @param {string} key - The key to sort by.
	 *
	 * @returns {Object} A new object sorted by the specified key's value.
	 */
	sortObjectByKey = (obj, key) => {
		const keys = Object.keys(obj).sort((a, b) => {
			return obj[b][key] - obj[a][key];
		});

		const sortedObj = {};
		for (let i = 0; i < keys.length; i++) {
			sortedObj[keys[i]] = obj[keys[i]];
		}

		return sortedObj;
	};

	/**
	 * Component group before creating the Symbol
	 *
	 * @returns component array
	 */
	groupComponents = () => {
		const loft = this.getLoftComponent();
		const allComponents = this.getAllComponents();
		const results = [];

		for (let k in allComponents) {
			const component = allComponents[k];
			component.transom = this._shedData.componentHasTransom(k, component.side)
			component.keys = [k];
			component.group =
				-1 !== ePackageType.indexOf(component.type) ? 'electrical' : component.type;

			const check = results.filter((data) => {
				return data.name === component.name && data.transom === component.transom;
			});

			if (check.length === 0) {
				results.push(component);
			} else {
				check[0].keys.push(k);
			}
		}

		const group = helpers.groupBy(results, 'group');

		if (loft) {
			group['loft'] = [
				{
					name: loft.name,
					type: 'loft',
				},
			];
		}

		if (this._shedData._isEnableTackRoom) {
			const currentTackRoom = jQuery('input.ssb-tackroom:checked').attr('data-option-value');
			group['partial_wall'] = [
				{
					name: currentTackRoom,
					type: 'partial_wall',
				},
			];
		}

		if (group['misc_exterior'] && group['misc_interior']) {
			group['misc'] = [...group['misc_exterior'], ...group['misc_interior']];
			delete group['misc_exterior'];
			delete group['misc_interior'];
		}

		return group;
	};

	/**
	 * Get component symbol
	 *
	 * @returns string of component symbol
	 */
	getComponentsSymbol = () => {
		const groupComponents = this.groupComponents();
		const components = [];
		for (let k in groupComponents) {
			const group = groupComponents[k];

			group.forEach((component, i: number) => {
				const { type, name, keys } = component;
				const label =
					'partial_wall' !== type
						? this._shedData.getComponentLabelIncludeAddOn(component)
						: name;
				let wildcard = this.getComponentInit('wildcard', type, name);
				wildcard = wildcard + (i + 1);

				if (label) components.push({ wildcard, type, label, name, keys });
			});
		}

		return components;
	};

	/**
	 * Get component symbol by Name
	 *
	 * @param name of component
	 */
	getComponentsSymbolByName = (name: string): string => {
		const components = this.getComponentsSymbol();
		const component = components.filter((c) => name === c.name);

		if (component.length > 0) {
			return component[0].wildcard;
		} else {
			return '';
		}
	};

	/**
	 * Get component symbol by Key
	 *
	 * @param key of component
	 */
	getComponentsSymbolByKey = (key: string): string => {
		const components = this.getComponentsSymbol();
		const component = components.filter((c) => c.keys && helpers.hasKeyInArray(c.keys, key));

		if (component.length > 0) {
			return component[0].wildcard;
		} else {
			return '';
		}
	};	

	/**
	 * Draw symbol in 2d floor plan
	 *
	 * @param text you want show
	 */
	drawSymbolIn2D = (text: string): fabric.Text => {
		return new fabric.Text(text, {
			fontSize: 12,
			fontWeight: 700,
			fill: '#000000',
			centeredRotation: true,
			fontFamily: this._fontFamily,
			backgroundColor: 'white',
		});
	};

	/**
	 * Set position for symbol
	 *
	 * @param mainObj
	 * @param wildcardObj
	 * @param side
	 */
	setSymbolPosition = (
		mainObj: fabric.Object,
		wildcardObj: fabric.Object,
		side: string,
		type: string,
	) => {
		let positionTop = mainObj.getCenterPoint().y - wildcardObj.width / 2;
		let positionLeft = mainObj.getCenterPoint().x - wildcardObj.height / 2;
		let offset = 28;

		switch (type) {
			case 'windows':
			case 'door':
				offset = 20;
				break;

			case 'vent':
				offset = 45;
				break;

			case 'breakerbox':
				offset = 22;
				break;

			case 'stair':
				offset = 40;
				break;

			case 'switch':
			case 'outlet':
				offset = 18;
				break;

			case 'misc_interior':
				offset = 0;
				break;
		}

		switch (side) {
			case 'back':
			case 'top_back':
			case 'left_inner_porch':
			case 'inner_back':
			case 'lean_to_back':
				positionTop += offset;

				break;

			case 'right_inner_porch':
			case 'inner_front':
			case 'front':
			case 'top_front':
			case 'porch':
			case 'lean_to_front':
				positionTop -= offset;

				break;

			case 'left_back':
			case 'left_front':
			case 'left_middle_porch':
			case 'front_inner_porch':
			case 'top_left':
			case 'inner_left':
			case 'left':
				positionLeft -= offset;

				break;

			case 'inner_right':
			case 'top_right':
			case 'dormer':
			case 'right':
			case 'lean_to_right':
				positionLeft += offset;

				break;

			case 'diagonal_right':
				positionTop -= 13;
				positionLeft += 13;

				break;

			default:
				break;
		}

		wildcardObj.top = positionTop;
		wildcardObj.left = positionLeft;
	};

	/**
	 * Draw Loft component Icon
	 */
	drawLoftComponentIcon = (loft) => {
		const dataLoft = loft.dataLoft;
		if (isEmptyObject(dataLoft)) return [];

		const results = [];
		const meshName = 'loft_obj';
		const angle = this.getComponentRotation(loft.side);
		const angleZ = this.getComponentRotation(loft.side) + 90;
		const shedWidth = this.scale(this.getShedWidth()) - 4;
		const shedDepth = this.scale(this._shedData.getDepth()) - 4;
		const wildcard = this.getComponentsSymbolByName(loft.name);
		const angleW = this.getWildcardRotation();
		const loftLine = {
			fill: 'rgba(0,0,0,0)',
			stroke: 'black',
			strokeWidth: 1,
			backgroundColor: 'rgba(0,0,0,0)',
			centeredRotation: true,
			strokeDashArray: [7, 10],
		};

		for (const side in dataLoft) {
			const width = dataLoft[side];
			const mesh = this._shedData.getMeshByName(`${meshName}_${side}`);
			let left = this.scale(width / 2);

			if ('structure_saltbox_mwshed' === this._shedData._shedType) {
				left += this.scale(
					shedWidth / this._scale / 2 -
						Math.abs(
							this._shedData._bones[this._measureBones['front'].left].position.x,
						),
				);
			}

			if ('front' === side || 'back' === side) {
				const loftObj = [
					{ x: 0, y: 0 },
					{ x: this.scale(width), y: 0 },
					{ x: this.scale(width), y: shedWidth },
					{ x: 0, y: shedWidth },
					{ x: 0, y: 0 },
				];

				const component = new fabric.Polyline(loftObj, {
					top: this.scale(mesh.position.z) - shedWidth / 2,
					left: -left,
					...loftLine,
				}).rotate(angle);

				const wildcardObj = this.drawSymbolIn2D(wildcard);
				const wildcardLeft =
					'back' === side
						? component.top - wildcardObj.width - this.scale(0.7)
						: component.top - this.scale(width) + this.scale(0.7);
				wildcardObj.top = wildcardLeft;
				wildcardObj.left = component.getCenterPoint().x;
				wildcardObj.rotate(angleW);

				results.push(component, wildcardObj);
			} else if ('left' === side || 'right' === side) {
				let left =
					'left' === side
						? this.scale(-this.getShedWidth() / 2 + width)
						: this.scale(this.getShedWidth() / 2);
				const loftObj = [
					{ x: 0, y: 0 },
					{ x: this.scale(width), y: 0 },
					{ x: this.scale(width), y: shedDepth },
					{ x: 0, y: shedDepth },
					{ x: 0, y: 0 },
				];

				const component = new fabric.Polyline(loftObj, {
					top: this.scale(mesh.position.z) - shedDepth / 2,
					left: -left,
					...loftLine,
				}).rotate(angleZ);

				const wildcardObj = this.drawSymbolIn2D(wildcard);
				const wildcardLeft =
					'right' === side
						? this.scale(-this.getShedWidth() / 2 + width / 2 + 0.7) -
							wildcardObj.height
						: this.scale(this.getShedWidth() / 2 - width / 2 - 0.7);

				wildcardObj.top = component.getCenterPoint().y;
				wildcardObj.left = wildcardLeft;

				wildcardObj.rotate(angleW);

				results.push(component, wildcardObj);
			}
		}

		return results;
	};

	drawTackRoomComponentIcon = () => {
		const results = [];
		const shedWidth = this.scale(this.getShedWidth());
		const angleZ = this.getComponentRotation('front') + 90;
		const tackRoomLine = {
			fill: 'rgba(0,0,0,0)',
			stroke: 'black',
			strokeWidth: 3,
			backgroundColor: 'rgba(0,0,0,0)',
			centeredRotation: true,
		};
		const currentTackRoom = jQuery('input.ssb-tackroom:checked').attr('data-option-value');
		const wildcard = this.getComponentsSymbolByName(currentTackRoom);
		const angleW = this.getWildcardRotation();
		const listMesh = ['partial_wall_front', 'partial_wall_back'];
		let isHasSymbol = false;
		const tackroomData = this._shedData._dataTackroom;
		listMesh.forEach((item) => {
			const mesh = this._shedData.getMeshByName(item);
			if (mesh) {
				let zerroNum = 'left' === tackroomData.position ? 1 : -0.7;
				const meshWidth =
					this.scale(this._shedData.getMeshWidth(mesh) + this._shedData._frameDepth * 2) +
					2;
				const loftObj = [
					{ x: 0, y: 0 },
					{ x: 0, y: meshWidth },
				];
				const left = shedWidth - meshWidth > 5 ? (shedWidth - meshWidth) / 2 : 0;
				const component = new fabric.Polyline(loftObj, {
					top: this.scale(mesh.position.z) - shedWidth / 2,
					left: -left,
					...tackRoomLine,
				}).rotate(angleZ);

				if (!isHasSymbol) {
					const wildcardObj = this.drawSymbolIn2D(wildcard);
					const wildcardLeft = this.scale(mesh.position.z - zerroNum);
					wildcardObj.top = wildcardLeft;
					wildcardObj.left = -left;
					wildcardObj.rotate(angleW);
					results.push(wildcardObj);
				}
				results.push(component);

				if ('center' === tackroomData.position) {
					isHasSymbol = true;
				}
			}
		});
		return results;
	};

	/**
	 * Draw icon of component in 2d floor plan
	 *
	 * @param component component data
	 *
	 * @returns fabric.Object || fabric.Group
	 */
	drawComponentIcon = (component) => {
		let { meshes, type, name, side, depth, rotation, key } = component;

		const degrees = 'floor' === side ? Tools.ToDegrees(rotation.y) : this.getComponentRotation(side);
		const results = [];
		const wildcardAngle = this.getWildcardRotation();
		let wildcard = this.getComponentsSymbolByKey(key);
		let width = this.scale(this._shedData.getComponentWidthFromNetWork(component));
		let height = 10;
		let position = this.calculateComponentPosition(component, width, height);
		let iconStr = '';
		let componentLine: fabric.Object;

		if (!wildcard) {
			wildcard = this.getComponentsSymbolByName(name);
		}

		const wildcardObj: fabric.Text = this.drawSymbolIn2D(wildcard);
		const strokeWidth = 1.5;

		switch (type) {
			case 'door':
				componentLine = new fabric.Polyline(
					[
						{ x: 0, y: 0 },
						{ x: width, y: 0 },
						{ x: width, y: height },
						{ x: 0, y: height },
						{ x: 0, y: 0 },
						{ x: 8, y: 0 },
						{ x: 8, y: height },
						{ x: width - 8, y: height },
						{ x: width - 8, y: 0 },
					],
					{
						top: position.top,
						left: position.left,
						fill: 'white',
						stroke: 'black',
						strokeWidth,
						backgroundColor: 'white',
						centeredRotation: true,
					},
				).rotate(degrees);

				this.setSymbolPosition(componentLine, wildcardObj, side, type);

				break;

			case 'windows':
				componentLine = new fabric.Polyline(
					[
						{ x: 0, y: height / 2 },
						{ x: width, y: height / 2 },
						{ x: width, y: 0 },
						{ x: 0, y: 0 },
						{ x: 0, y: height },
						{ x: width, y: height },
						{ x: width, y: height / 2 },
					],
					{
						top: position.top,
						left: position.left,
						fill: 'white',
						stroke: 'black',
						strokeWidth,
						backgroundColor: 'white',
						centeredRotation: true,
					},
				).rotate(degrees);

				this.setSymbolPosition(componentLine, wildcardObj, side, type);

				break;

			case 'skylight_window':
				const componentHeight = this.scale(
					this._shedData.getComponentHeightFromNetWork(component),
				);
				height = helpers.toFixed3(
					helpers.getCosFromDegrees(this._shedData.getRoofDegree()) * componentHeight,
				);
				position = this.calculateComponentPosition(component, width, height);

				componentLine = new fabric.Polyline(
					[
						{ x: 0, y: 0 },
						{ x: width, y: 0 },
						{ x: width, y: height },
						{ x: 0, y: height },
						{ x: 0, y: 0 },
					],
					{
						top: position.top,
						left: position.left,
						fill: 'white',
						stroke: 'black',
						strokeWidth,
						backgroundColor: 'white',
						centeredRotation: true,
					},
				).rotate(degrees);

				this.setSymbolPosition(componentLine, wildcardObj, side, type);

				break;

			case 'vent':
				const customVentIcon = this._shedData.getSettingData('custom_vent_icon');

				if (customVentIcon) {
					fabric.loadSVGFromString(customVentIcon, (objects, options) => {
						const obj = fabric.util.groupSVGElements(objects, options);
						position = this.calculateComponentPosition(
							component,
							obj.width,
							obj.height,
						);
						obj.set({ left: position.left, top: position.top + 1 }).rotate(degrees);

						componentLine = obj;
					});

					this.setSymbolPosition(componentLine, wildcardObj, side, type);
				} else {
					componentLine = new fabric.Polyline(
						[
							{ x: 0, y: height },
							{ x: 0, y: 0 },
							{ x: width, y: 0 },
							{ x: width, y: height },
							{ x: 0, y: height },
							{ x: width / 3, y: 0 },
							{ x: width / 1.5, y: 0 },
							{ x: width / 3, y: height },
							{ x: width / 1.5, y: height },
							{ x: width, y: 0 },
						],
						{
							top: position.top,
							left: position.left,
							fill: 'white',
							stroke: 'black',
							strokeWidth,
							backgroundColor: 'white',
							centeredRotation: true,
						},
					).rotate(degrees);

					this.setSymbolPosition(componentLine, wildcardObj, side, type);
				}

				break;

			case 'workbench':
			case 'shelf':
				height = this.scale(1);
				position = this.calculateComponentPosition(component, width, height);

				componentLine = new fabric.Polyline(
					[
						{ x: 0, y: height },
						{ x: 0, y: 0 },
						{ x: width, y: 0 },
						{ x: width, y: height },
					],
					{
						top: position.top,
						left: position.left,
						fill: 'rgba(0,0,0,0)',
						stroke: 'black',
						strokeWidth,
						centeredRotation: true,
					},
				).rotate(degrees);

				this.setSymbolPosition(componentLine, wildcardObj, side, type);

				break;

			case 'cupola':
				const halfBoxWidth = 5;
				height = width;
				position = this.calculateComponentPosition(component, width, height);

				componentLine = new fabric.Polyline(
					[
						{ x: 0, y: 0 },
						{ x: width, y: 0 },
						{ x: width, y: height },
						{ x: 0, y: height },
						{ x: 0, y: 0 },
						{ x: width / 2 - halfBoxWidth, y: height / 2 - halfBoxWidth },
						{ x: width / 2 + halfBoxWidth, y: height / 2 - halfBoxWidth },
						{ x: width, y: 0 },
						{ x: width / 2 + halfBoxWidth, y: height / 2 - halfBoxWidth },
						{ x: width / 2 + halfBoxWidth, y: height / 2 + halfBoxWidth },
						{ x: width, y: height },
						{ x: width / 2 + halfBoxWidth, y: height / 2 + halfBoxWidth },
						{ x: width / 2 - halfBoxWidth, y: height / 2 + halfBoxWidth },
						{ x: 0, y: height },
						{ x: width / 2 - halfBoxWidth, y: height / 2 + halfBoxWidth },
						{ x: width / 2 - halfBoxWidth, y: height / 2 - halfBoxWidth },
					],
					{
						top: position.top,
						left: position.left,
						fill: 'rgba(0,0,0,0)',
						stroke: 'black',
						strokeWidth,
						centeredRotation: true,
					},
				);

				wildcardObj.top = componentLine.getCenterPoint().y - wildcardObj.width / 2;
				wildcardObj.left = componentLine.left + height + this.scale(0.1);

				break;

			case 'dormer':
				const boxWidth = 6;
				width = this.scale(this._shedData.getComponentDepth(meshes));
				height = this._shedData.isGableDormer(component.name)
					? this.scale(
							this._shedData.getGableDormerDistance(
								`${component.name}_frame_obj`,
								meshes,
								'Dormer_B_F_T',
								'Dormer_B_B_T',
								'z',
							),
						)
					: this.scale(this._shedData.getFlatDormerWidth());
				position = this.calculateComponentPosition(component, width, height);

				componentLine = new fabric.Polyline(
					[
						{ x: boxWidth, y: height },
						{ x: boxWidth, y: 0 },
						{ x: 0, y: 0 },
						{ x: 0, y: height },
						{ x: width, y: height },
						{ x: width, y: 0 },
						{ x: width - boxWidth, y: 0 },
						{ x: width - boxWidth, y: height },
						{ x: width - boxWidth, y: height - boxWidth },
						{ x: boxWidth, y: height - boxWidth },
					],
					{
						top: position.top,
						left: position.left,
						fill: 'rgba(0,0,0,0)',
						stroke: 'black',
						strokeWidth,
						centeredRotation: true,
					},
				).rotate(degrees);

				wildcardObj.top = componentLine.getCenterPoint().y;
				wildcardObj.left = componentLine.left;

				break;

			case 'light':
				width = 21;
				height = 21;
				position = this.calculateComponentPosition(component, width, height);
				iconStr = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.03902 15.9963C7.80249 18.7598 12.283 18.7598 15.0464 15.9963V15.9963C17.8099 13.2328 17.8099 8.75236 15.0464 5.98889V5.98889C12.283 3.22542 7.80249 3.22542 5.03902 5.98889V5.98889C2.27555 8.75236 2.27555 13.2328 5.03902 15.9963V15.9963Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.75384 15.2815C3.38515 12.9128 3.38515 9.07239 5.75384 6.70371C8.12252 4.33502 11.9629 4.33502 14.3316 6.70371C16.7003 9.07239 16.7003 12.9128 14.3316 15.2815C11.9629 17.6502 8.12252 17.6502 5.75384 15.2815ZM15.0464 15.9963C12.283 18.7598 7.80249 18.7598 5.03902 15.9963C2.27555 13.2328 2.27555 8.75236 5.03902 5.98889C7.80249 3.22542 12.283 3.22542 15.0464 5.98889C17.8099 8.75236 17.8099 13.2328 15.0464 15.9963Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 19.2489L14.7511 15L14 15.7511L18.2489 20L19 19.2489Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6 6.24889L1.75111 2L1 2.75111L5.24889 7L6 6.24889Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.75111 20L6 15.7511L5.24889 15L1 19.2489L1.75111 20Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.7511 7L19 2.75111L18.2489 2L14 6.24889L14.7511 7Z" fill="black"/></svg>`;

				fabric.loadSVGFromString(iconStr, (objects, options) => {
					const obj = fabric.util.groupSVGElements(objects, options);
					obj.set({ left: position.left, top: position.top });

					componentLine = obj;
				});

				wildcardObj.top = componentLine.getCenterPoint().y - wildcardObj.width / 2;
				wildcardObj.left = componentLine.left + height + this.scale(0.1);

				break;

			case 'breakerbox':
				width = 30;
				height = 17;
				position = this.calculateComponentPosition(component, width, height);
				iconStr = `<svg width="30" height="17" viewBox="0 0 30 17" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_110_30" fill="white"><path d="M0 17H30V0H0V17Z"/></mask><path d="M0 17V18H-1V17H0ZM30 17H31V18H30V17ZM30 0V-1H31V0H30ZM0 0H-1V-1H0V0ZM0 16H30V18H0V16ZM29 17V0H31V17H29ZM30 1H0V-1H30V1ZM1 0V17H-1V0H1Z" fill="black" mask="url(#path-1-inside-1_110_30)"/><path d="M9.83747 13.25L15 4.94693L20.1625 13.25H9.83747Z" stroke="black"/></svg>`;

				fabric.loadSVGFromString(iconStr, (objects, options) => {
					const obj = fabric.util.groupSVGElements(objects, options);
					obj.set({ left: position.left, top: position.top }).rotate(degrees);

					componentLine = obj;
				});

				this.setSymbolPosition(componentLine, wildcardObj, side, type);

				break;

			case 'switch':
				width = 17;
				height = 22;
				position = this.calculateComponentPosition(component, width, height);
				iconStr = `<svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_361_6067)"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.26953 1V6.5C4.26953 7.60457 5.16496 8.5 6.26953 8.5C7.3741 8.5 8.26953 7.60457 8.26953 6.5V3.66667H9.26953V6.5C9.26953 8.15685 7.92639 9.5 6.26953 9.5C4.61268 9.5 3.26953 8.15685 3.26953 6.5V1H4.26953Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.2695 3.5V9H14.2695V3.5C14.2695 1.84315 12.9264 0.5 11.2695 0.5C9.61268 0.5 8.26953 1.84315 8.26953 3.5V6.66667H9.26953V3.5C9.26953 2.39543 10.165 1.5 11.2695 1.5C12.3741 1.5 13.2695 2.39543 13.2695 3.5Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.2695 5.5H0.769531V4.5H16.2695V5.5Z" fill="black"/></g><defs><clipPath id="clip0_361_6067"><rect width="17" height="10" fill="white"/></clipPath></defs></svg>`;

				fabric.loadSVGFromString(iconStr, (objects, options) => {
					const obj = fabric.util.groupSVGElements(objects, options);
					obj.set({ left: position.left, top: position.top }).rotate(degrees);

					componentLine = obj;
				});

				this.setSymbolPosition(componentLine, wildcardObj, side, type);

				break;

			case 'outlet':
				width = 15;
				height = 21;
				position = this.calculateComponentPosition(component, width, height);
				iconStr = `<svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.3125 3.19639e-07C3.27392 1.43107e-07 -1.43108e-07 3.27392 -3.1964e-07 7.3125V7.3125C-4.96172e-07 11.3511 3.27392 14.625 7.3125 14.625L7.6875 14.625C11.7261 14.625 15 11.3511 15 7.3125V7.3125C15 3.27392 11.7261 5.12563e-07 7.6875 3.36031e-07L7.3125 3.19639e-07Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.6875 14.625L7.3125 14.625C3.27392 14.625 -4.96172e-07 11.3511 -3.1964e-07 7.3125C-1.43108e-07 3.27392 3.27392 1.43107e-07 7.3125 3.19639e-07L7.6875 3.36031e-07C11.7261 5.12563e-07 15 3.27392 15 7.3125C15 11.3511 11.7261 14.625 7.6875 14.625ZM7.6875 1C11.1738 1 14 3.8262 14 7.3125C14 10.7988 11.1738 13.625 7.6875 13.625L7.3125 13.625C3.8262 13.625 1 10.7988 1 7.3125C1 3.8262 3.8262 1 7.3125 1L7.6875 1Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.25 21L9.25 0.75L10.25 0.75L10.25 21L9.25 21Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.75 21L4.75 0.75L5.75 0.75L5.75 21L4.75 21Z" fill="black"/></svg>`;

				fabric.loadSVGFromString(iconStr, (objects, options) => {
					const obj = fabric.util.groupSVGElements(objects, options);
					obj.set({ left: position.left, top: position.top }).rotate(degrees);

					componentLine = obj;
				});

				this.setSymbolPosition(componentLine, wildcardObj, side, type);

				break;

			case 'stair':
				height = undefined !== depth ? this.scale(depth) : 0;
				const offset = (10 * height) / 100;
				const space = (height - 2 * offset) / 4;
				position = this.calculateComponentPosition(component, height, width);
				componentLine = new fabric.Polyline(
					[
						{ x: 0, y: 0 },
						{ x: offset, y: 0 },
						{ x: offset, y: width },
						{ x: offset + space, y: width },
						{ x: offset + space, y: 0 },
						{ x: offset + 2 * space, y: 0 },
						{ x: offset + 2 * space, y: width },
						{ x: offset + 3 * space, y: width },
						{ x: offset + 3 * space, y: 0 },
						{ x: offset + 4 * space, y: 0 },
						{ x: offset + 4 * space, y: width },
						{ x: 2 * offset + 4 * space, y: width },
						{ x: offset + 4 * space, y: width },
						{ x: offset + 4 * space, y: 0 },
						{ x: 2 * offset + 4 * space, y: 0 },
						{ x: offset + 3 * space, y: 0 },
						{ x: offset + 3 * space, y: width },
						{ x: offset + 4 * space, y: width },
						{ x: offset + 2 * space, y: width },
						{ x: offset + 2 * space, y: 0 },
						{ x: offset + 3 * space, y: 0 },
						{ x: offset + space, y: 0 },
						{ x: offset + space, y: width },
						{ x: offset + 2 * space, y: width },
						{ x: 0, y: width },
						{ x: offset, y: width },
						{ x: offset, y: 0 },
						{ x: offset + space, y: 0 },
						{ x: 0, y: 0 },
					],
					{
						top: position.top,
						left: position.left,
						fill: 'rgba(0,0,0,0)',
						stroke: 'black',
						strokeWidth,
						centeredRotation: true,
					},
				).rotate(degrees);

				this.setSymbolPosition(componentLine, wildcardObj, side, type);

				break;

			case 'misc_exterior':
			case 'misc_interior':
				height = this.scale(this._shedData.getComponentLengthFromNetWork(component));
				if (width <= 18) {
					width = 18;
					height = 18;
				}

				position = this.calculateComponentPosition(component, width, height);
				componentLine = new fabric.Polyline(
					[
						{ x: 0, y: height },
						{ x: 0, y: 0 },
						{ x: width, y: 0 },
						{ x: width, y: height },
						{ x: width, y: 0 },
						{ x: 0, y: height },
						{ x: width, y: height },
						{ x: 0, y: 0 },
					],
					{
						top: position.top,
						left: position.left,
						fill: 'rgba(0,0,0,0)',
						stroke: 'black',
						strokeWidth,
						centeredRotation: true,
					},
				).rotate(degrees);

				this.setSymbolPosition(componentLine, wildcardObj, side, type);

				break;

			default:
				break;
		}

		results.push(componentLine, wildcardObj);
		wildcardObj.rotate(wildcardAngle);

		return results;
	};

	/**
	 * Recalculate component coordinates when placed on 2d floor plan
	 *
	 * @param component component data
	 * @param width component width
	 * @param height component height
	 *
	 * @returns new position of component
	 */
	calculateComponentPosition = (component, width: number, height: number) => {
		let { side, type, name } = component;

		const behavior = this._shedData.getBehavior(name, type);
		let top = this.scale(component.meshes[0].position.z) - (height / 2 + 1);
		let left = -(this.scale(component.meshes[0].position.x) + width / 2);
		const groupType = ['workbench', 'shelf', 'breakerbox', 'switch', 'outlet', 'stair'];

		switch (side) {
			case 'back':
			case 'left_inner_porch':
			case 'inner_back':
			case 'lean_to_back':
				if (helpers.hasKeyInArray(groupType, behavior)) {
					top += height / 2;
				} else if ('misc_exterior' === type) {
					top -= height / 2;
				}

				break;

			case 'right_inner_porch':
			case 'inner_front':
			case 'front':
			case 'lean_to_front':
				if (helpers.hasKeyInArray(groupType, behavior)) {
					top -= height / 2;
				} else if ('misc_exterior' === type) {
					top += height / 2;
				}

				break;

			case 'left_back':
			case 'left_front':
			case 'left_middle_porch':
			case 'front_inner_porch':
			case 'top_left':
			case 'inner_left':
			case 'left':
				if (helpers.hasKeyInArray(groupType, behavior)) {
					left -= height / 2;
				} else if ('misc_exterior' === type) {
					left += height / 2;
				}

				break;

			case 'lean_to_right':
			case 'inner_right':
			case 'top_right':
			case 'dormer':
			case 'right':
				if (helpers.hasKeyInArray(groupType, behavior)) {
					left += height / 2;
				} else if ('misc_exterior' === type) {
					left -= height / 2;
				}

				break;

			case 'diagonal_right':
				if ('misc_exterior' === type) {
					left -= height / 2;
					top += height / 2;
				} else {
					if ('workbench' === behavior || 'shelf' === behavior) {
						left += height / 2 - 6;
						top -= height / 2 - 6;
					} else if (
						'breakerbox' === behavior ||
						'switch' === behavior ||
						'outlet' === behavior
					) {
						left += height / 2 - 4;
						top -= height / 2 - 4;
					}
				}

				break;

			case 'roof_left':
				left += height / 2;

				break;

			case 'roof_right':
				left -= height / 2;

				break;

			default:
				break;
		}

		return { top, left };
	};

	/**
	 * Get Rotation for component when draw in 2d floor plan
	 *
	 * @param side side of shed
	 *
	 * @returns new rotation
	 */
	getComponentRotation = (side: string): number => {
		switch (side) {
			case 'back':
			case 'left_inner_porch':
			case 'inner_back':
			case 'lean_to_back':
				return 180;

			case 'left_back':
			case 'left_front':
			case 'front_inner_porch':
			case 'roof_left':
			case 'inner_left':
			case 'left':
				return 270;

			case 'right':
			case 'top_right':
			case 'inner_right':
			case 'top_left':
			case 'roof_right':
			case 'dormer':
			case 'left_middle_porch':
			case 'lean_to_right':
				return 90;

			case 'diagonal_right':
				return 45;

			default:
				return 0;
		}
	};

	/**
	 * Get Wildcard Rotation
	 *
	 * @param side side of shed
	 *
	 * @returns new rotation
	 */
	getWildcardRotation = (): number => {
		return this._isShedRotation ? 270 : 0;
	};

	/**
	 * Get Component default define data
	 *
	 * @param field What type of data do you want to return? wildcard | icon
	 * @param componentType Type of component
	 * @param componentName Name of component
	 * @returns return icon | wildcard
	 */
	getComponentInit = (field: string, componentType: string, componentName: string): string => {
		let icon: string = '';
		let wildcard: string = '';

		switch (componentType) {
			case 'door':
				wildcard = 'D';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 7H1V11H17V7ZM0 6V12H18V6H0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 7H1V11H2V7ZM0 6V12H3V6H0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17 7H16V11H17V7ZM15 6V12H18V6H15Z" fill="black"/></svg>`;
				break;

			case 'windows':
				wildcard = 'W';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 8.5H17.5V5.5H0.5V8.5Z" stroke="black"/><rect x="0.5" y="8.5" width="17" height="3" stroke="black"/></svg>`;
				break;

			case 'skylight_window':
				wildcard = 'K';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_102_3" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="6" width="18" height="6"><path d="M18 6H0V12H18V6Z" fill="white"/></mask><g mask="url(#mask0_102_3)"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 11H1V7H17V11ZM0 12V6H18V12H0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.64648 11.8536L0.646484 6.85359L1.35359 6.14648L6.35359 11.1465L5.64648 11.8536Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6465 11.8536L6.64648 6.85359L7.35359 6.14648L12.3536 11.1465L11.6465 11.8536Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6465 11.8536L12.6465 6.85359L13.3536 6.14648L18.3536 11.1465L17.6465 11.8536Z" fill="black"/></g></svg>`;
				break;

			case 'switch':
				wildcard = 'E';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 5V10.5C4 11.8807 5.11929 13 6.5 13V13C7.88071 13 9 11.8807 9 10.5V7.66667" stroke="black"/><path d="M9 10.6667V7.5C9 6.11929 10.1193 5 11.5 5V5C12.8807 5 14 6.11929 14 7.5V13" stroke="black"/><path d="M1 9H16.5" stroke="black"/></svg>`;
				break;

			case 'breakerbox':
				wildcard = 'E';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 13H1V5H17V13ZM0 14V4H18V14H0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.99999 6L5.53589 12H12.4641L8.99999 6ZM8.99999 8L7.26794 11H10.732L8.99999 8Z" fill="black"/></svg>`;
				break;

			case 'loft':
				wildcard = 'L';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_345_5168)"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 5L18 6.125L17 6.125L17 5L18 5ZM1 5L0 5L-5.11423e-08 6.125L1 6.125L1 5ZM1 14L1 12.875L-3.57996e-07 12.875L-4.09139e-07 14L1 14ZM17 14L18 14L18 12.875L17 12.875L17 14ZM18 8.375L17 8.375L17 10.625L18 10.625L18 8.375ZM15.3 14L15.3 13L13.5 13L13.5 14L15.3 14ZM11.7 14L11.7 13L9.9 13L9.9 14L11.7 14ZM8.1 14L8.1 13L6.3 13L6.3 14L8.1 14ZM4.5 14L4.5 13L2.7 13L2.7 14L4.5 14ZM-2.55712e-07 10.625L1 10.625L1 8.375L-1.53427e-07 8.375L-2.55712e-07 10.625ZM2.7 5L2.7 6L4.5 6L4.5 5L2.7 5ZM6.3 5L6.3 6L8.1 6L8.1 5L6.3 5ZM9.9 5L9.9 6L11.7 6L11.7 5L9.9 5ZM13.5 5L13.5 6L15.3 6L15.3 5L13.5 5Z" fill="black"/></g><defs><clipPath id="clip0_345_5168"><rect width="18" height="18" fill="white"/></clipPath></defs></svg>`;
				break;

			case 'light':
				wildcard = 'E';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8715 5.83571L15.3536 3.35359L14.6465 2.64648L12.1644 5.1286C11.3024 4.42326 10.2006 4.00008 9 4.00008C7.6784 4.00008 6.47656 4.51283 5.58256 5.35025L3.1185 2.66218L2.38135 3.33791L4.92071 6.10812C4.34089 6.92452 4 7.92249 4 9.00008C4 10.2007 4.42318 11.3025 5.12853 12.1644L2.64648 14.6465L3.35359 15.3536L5.83563 12.8715C6.69757 13.5769 7.79937 14.0001 9 14.0001C10.2006 14.0001 11.3024 13.5769 12.1644 12.8715L14.6465 15.3537L15.3536 14.6466L12.8715 12.1644C13.5768 11.3025 14 10.2007 14 9.00008C14 7.79944 13.5768 6.69764 12.8715 5.83571ZM9 13.0001C11.2091 13.0001 13 11.2092 13 9.00008C13 6.79094 11.2091 5.00008 9 5.00008C6.79086 5.00008 5 6.79094 5 9.00008C5 11.2092 6.79086 13.0001 9 13.0001Z" fill="black"/></svg>`;
				break;

			case 'workbench':
				wildcard = 'T';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 15H1V3H17V15ZM0 16V2H18V16H0Z" fill="black"/></svg>`;
				break;

			case 'shelf':
				wildcard = 'S';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 15H1V3H17V15ZM0 16V2H18V16H0Z" fill="black"/></svg>`;
				break;

			case 'vent':
				wildcard = 'V';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_102_3" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="6" width="18" height="6"><path d="M18 6H0V12H18V6Z" fill="white"/></mask><g mask="url(#mask0_102_3)"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 11H1V7H17V11ZM0 12V6H18V12H0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.64648 11.8536L0.646484 6.85359L1.35359 6.14648L6.35359 11.1465L5.64648 11.8536Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6465 11.8536L6.64648 6.85359L7.35359 6.14648L12.3536 11.1465L11.6465 11.8536Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6465 11.8536L12.6465 6.85359L13.3536 6.14648L18.3536 11.1465L17.6465 11.8536Z" fill="black"/></g></svg>`;

				const customVentSymbolIcon =
					this._shedData.getSettingData('custom_vent_symbol_icon');
				if (customVentSymbolIcon) {
					icon = customVentSymbolIcon;
				}

				break;

			case 'dormer':
				wildcard = 'C';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6H2V13H3V11V6ZM1 14H3H4H14H15H17V5H14V11L4 11V5H1V14ZM14 12L4 12V13H14V12ZM15 13H16V6H15V11V13Z" fill="black"/></svg>`;
				break;

			case 'cupola':
				wildcard = 'P';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 15H3V3H15V15ZM2 16V2H16V16H2Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1465 15.8533L11 11.7071L11.7071 11L15.8536 15.1462L15.1465 15.8533Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.29301 7.20681L2.14648 3.06062L2.85359 2.35352L7.00012 6.4997L6.29301 7.20681Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.25022 15.25L6.39641 11.1035L7.10352 11.8106L2.95733 15.9571L2.25022 15.25Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.8967 6.39653L15.0429 2.25L15.75 2.95711L11.6038 7.10363L10.8967 6.39653Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11 7H7V11H11V7ZM6 6V12H12V6H6Z" fill="black"/></svg>`;
				break;

			case 'outlet':
				wildcard = 'E';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_345_5156)"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.75 8.875V9.125C11.75 11.8174 9.56739 14 6.875 14C4.18261 14 2 11.8174 2 9.125V8.875C2 6.18261 4.18261 4 6.875 4C9.56739 4 11.75 6.18261 11.75 8.875ZM3 8.875C3 6.7349 4.7349 5 6.875 5C9.0151 5 10.75 6.7349 10.75 8.875V9.125C10.75 11.2651 9.0151 13 6.875 13C4.7349 13 3 11.2651 3 9.125V8.875Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 7.83398H2.75V6.83398H15.75V7.83398Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 10.834H2.75V9.83398H15.75V10.834Z" fill="black"/></g><defs><clipPath id="clip0_345_5156"><rect width="18" height="18" fill="white"/></clipPath></defs></svg>`;
				break;

			case 'runner':
				wildcard = '';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.385 5.18306C11.1409 4.93898 10.7452 4.93898 10.5011 5.18306C10.257 5.42714 10.257 5.82286 10.5011 6.06694L12.6161 8.18198H2.625C2.27982 8.18198 2 8.4618 2 8.80698C2 9.15216 2.27982 9.43198 2.625 9.43198H12.6161L10.5011 11.547C10.257 11.7911 10.257 12.1868 10.5011 12.4309C10.7452 12.675 11.1409 12.675 11.385 12.4309L14.5669 9.24892C14.811 9.00484 14.811 8.60912 14.5669 8.36504L11.385 5.18306Z" fill="black"/></svg>`;
				break;

			case 'stair':
				wildcard = 'R';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 3V8L3 8V3L15 3ZM16 9V8V3V2V0H15V2L3 2V0H2V2V3V8V9V14V15V18H3V15L15 15V18H16V15V14V9ZM15 14V9L3 9V14L15 14Z" fill="black"/></svg>`;
				break;

			case 'misc':
			case 'misc_interior':
			case 'misc_exterior':
				wildcard = 'M';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_8634_4322)"><rect x="0.5" y="0.5" width="17" height="17" stroke="black"/><path d="M0 0L18 18M18 0L0 18" stroke="black"/></g><defs><clipPath id="clip0_8634_4322"><rect width="18" height="18" fill="white"/></clipPath></defs></svg>`;
				break;

			case 'partial_wall':
				wildcard = 'X';
				icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 11.5H17.5V6.5H0.5V11.5Z" stroke="black"/></svg>`;
				break;

			default:
				break;
		}

		if ('wildcard' === field) return wildcard;

		return icon;
	};

	/**
	 * Get Loft component and push to components array
	 */
	getLoftComponent = () => {
		const loftHTML = jQuery('.group-upgrade-loft .ssb_loft:checked');
		if (0 === loftHTML.length || 'none' === loftHTML.val()) return false;

		const meshes1 = this._shedData.getMeshByName('loft_obj');
		const meshes2 = this._shedData.getMeshByName('loft_clone');
		const dataLoft = this._shedData.formatLoftSizeSide(loftHTML.data('size-side'));
		const loftName = loftHTML.data('option-value');

		if (isEmptyObject(dataLoft)) return false;

		return { name: loftName, side: 'left', dataLoft, meshes1, meshes2 };
	};

	/**
	 * Loads a font using FontFaceObserver.
	 * @param {string} font - The name of the font to load.
	 */
	loadFont = (font) => {
		const myFont = new FontFaceObserver(font);
		myFont
			.load()
			.then(function (e) {})
			.catch(function (e) {
				console.log(e);
			});
	};

	/**
	 * Scale item with scale ratio
	 *
	 * @param point position need to be scale
	 *
	 * @returns new position after scale
	 */
	scale = (point: number) => {
		return point * this._scale;
	};

	/**
	 * Check to rotate model by runner
	 *
	 * @param {Number} width model width
	 * @param {Number} depth model depth
	 *
	 * @returns {Boolean}
	 */
	isShowRunnerDirection = (width: number, depth: number) => {
		if (width !== depth) {
			return false;
		}

		return helpers.isEnableRunnerDirection() && !this._shedData.isEnableOuterJoist();
	};
}
